import React, { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import WrapperPage from "../../components/WrapperPage";
import MobileAppDownloadBlock from "../../components/MobileAppDownloadBlock";
import "./style.scss";
import Butterflies from "../../components/Butterflies";
import ROUTES from "../../utils/routes.js";

export default function CompatibilitySharePage() {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    document.querySelector("body").classList.add("overflow-hidden");
    return () => {
      document.querySelector("body").classList.remove("overflow-hidden");
    };
  }, []);
  return (
    <div className="compatibility-page-wrapper centering-page">
      <Butterflies
        type="clear"
        className="compatibility-page-butterflies"
        countEllipses={2}
      />
      <WrapperPage backBtn>
        <div className="compatibility-page-wrapper__container">
          <div className="compatibility-page-wrapper__title">
            {t("compatibility_share_page.title")}{" "}
            <span
              data-text={t("compatibility_share_page.in_touch")}
              className="compatibility-page-wrapper__title-highlight neon-text"
            >
              {t("compatibility_share_page.in_touch")}
            </span>
          </div>
          <div className="compatibility-page-wrapper__text">
            {t("compatibility_share_page.text")}
          </div>
          <div className="compatibility-page-wrapper__actions">
            <MobileAppDownloadBlock isHideTitle></MobileAppDownloadBlock>
          </div>
        </div>
      </WrapperPage>
    </div>
  );
}
